/* globals fbq dataLayer window */

import React, { useState, useEffect, useRef } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { Button, Card, Col, Row, Checkbox, Select } from 'react-materialize';

import Cleave from 'cleave.js/react';
import _ from 'lodash';
import Raven from 'raven-js';
import Pricing from '../components/Pricing';
import PrettyDate from '../components/PrettyDate';
import ImageUpload from '../components/ImageUpload';
// import { calculateCosts } from '../../../costCalculator';

import { couponIsValid, calculateCosts } from '../../costCalculator';
import { loadCoupon } from '../../brain2';
import {
  findOrCreateVehicleId,
  getVehicleType,
  createVehicle,
  uploadVehicleImages,
} from '../../vehicleHelper';
import {
  changeCouponHelper,
  datetimeToTime,
  isCouponAlreadyUsed,
  setPageTitle,
  shouldUseFacebookPixel,
  tracRudderStackkEvent,
} from '../../helper';
import {
  createTireNote,
  getActivePaymentMethods,
  skipPaymentInformation,
} from './checkoutHelper';
import ReviewPrices from './ReviewPrices';
import ReviewServices from './ReviewServices';
import ReviewYourCar from './ReviewYourCar';
import {
  apiPost,
  storeAccessToken,
  hasAccessToken,
  loadCompatibleDates,
} from '../../brainApi';
import Moment from 'moment';

const ConfirmAppointment = (props) => {
  setPageTitle('Confirm Appointments');

  const {
    homeAddress,
    pricing,
    dispatch,
    account,
    vehicles,
    keyosk,
    parking,
    schedule,
    cart,
    scheduledWorks,
    coupon,
    couponList,
    customerLocation,
    clientLocations,
    z3pConfiguration,
    diagnostic,
    bookingImages,
    vehicle,
    referrer,


    tireDetails,
    tireNotes,
    detailingNote,
    selectedPaymentMethod,
    quoteId,
    customDiscount,
    taxRate,
    activePaymentMethods
  } = props;
  const LOCAL_KEY_Location = "KeyLocation";

  const {
    z3p_client_name: z3pEnv,
    pickup_delivery_service_location: pickupDeliveryServiceLocation,
    scheduling_system: schedulingSystem,
    service_locations: serviceLocations,
    is_skipping_vehicle,
    allow_additional_user_sms_communications: allowAdditionalContacts,
    is_hiding_price_in_booking,
    is_guest_checkout_enabled: guestCheckout,
    how_did_hear_options: howDidHearOptions,
    is_how_did_hear_question_enabled: isHowDidHearQuestionEnabled,
    show_fleet_in_booking_app: showFleetField,

    customer_facing_name: serviceProviderName,
    is_using_stripe: isUsingStripe,
    is_using_square: isUsingSquare,
    terms_and_conditions_url,
    is_charging_cancellation_fee: hasCancellationFeePolicy,
  } = z3pConfiguration;

  const [isFree, setIsFree] = useState(false);
  const hasWorkplaceService = serviceLocations.includes('workplace');
  const hasShopService = serviceLocations.includes('shop');
  const LOCAL_STORAGE_KEY = "uploadedImagesBase64";
  const LOCAL_TireQuntityValue = 'TireQuntityValue';

  const [processing, setProcessing] = useState(false);
  const [couponCode, setCouponCode] = useState('');
  const [couponMessage, setCouponMessage] = useState('');
  const [tipAmountDollars, setTipAmountDollars] = useState(0);
  const [checkTermsAlert, setCheckTermsAlert] = useState(false);
  const [additionalContactList, setAdditionalContactList] = useState([]);
  const [areAdditionalContactsValid, setAreAdditionalContactsValid] = useState(
    true,
  );
  const [customerExists, setCustomerExists] = useState(false);
  const [inputValidationMessage, setInputValidationMessage] = useState(null);
  const [customerInfo, setCustomerInfo] = useState({
    first_name: '',
    last_name: '',
    email: '',
    cellPhone: '',
  });
  const isAtHomeService = !!homeAddress.addressIDSelected;
  const [agreedToReceiveTexts, setAgreedToReceiveTexts] = useState(false);
  const LOCAL_DECRIPTION_KEY = "Decription_Key";
  const [customerNote, setCustomerNote] = useState(
    diagnostic.completeDescription ||
    schedule.customerNote ||
    schedule.note ||
    '',
  );
  const [base64Images, setBase64Images] = useState(
    bookingImages.length > 0 ? bookingImages : [],
  );
  const [isImageType, setIsImageType] = useState({
    type: 'new',
    old_image_name: '',
    index: 0,
  });
  const [selectedHowDidHear, setSelectedHowDidHear] = useState('');
  const [fleetAccountName, setFleetAccountName] = useState(null);
  const [imgError, setImgError] = useState(null);
  const [loading, setLoading] = useState(false);
  const MAX_SIZE_MB = 5; // Maximum file size in MB
  const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024; // Convert MB to bytes
  const MAX_IMAGES = 5; // Maximum number of images
 
  const UPLOADED_IMAGES_ARRAY = "UPLOADEDIMAGESARRAY";
  const [imageArray, setimageArray] = useState(localStorage.getItem(UPLOADED_IMAGES_ARRAY));
  
  const [timeTakenError, setTimeTakenError] = useState(false);
  const [paymentFailed, setPaymentFailed] = useState(false);
  const [showPaymentMethodSection, setShowPaymentMethodSection] = useState(
    false,
  );

  let folderName = 'stage-appointment-images';
  if (process.env.REACT_APP_ENVIRO === 'production') {
    folderName = 'appointment-images';
  }

  useEffect(() => {
    // If the customer doesn't have anything in their cart,
    // direct them back to the Simple Services page.
    if (!cart || cart.length === 0) {
      browserHistory.push('/pricing/simple');
    }
    // If the customer got here without selecting a keyosk/parking and they are not receiving at-home service,
    // direct them back to the location selection page.
    if (
      hasWorkplaceService &&
      (!keyosk || !parking) &&
      !homeAddress.keyLocationNote
    ) {
      browserHistory.push('/pricing/location');
    }

    // User should have a schedule before they hit this page
    if (!schedule) {
      browserHistory.push('/pricing/schedule');
    }

    // Since quotes may not have a vehicle attached, check if there is vehicle info.
    const hasVehicle = !!pricing?.vehicleType;

    // If there's no vehicleId, either find one in their existing vehicles,
    // or save this vehicle to get a new vehicleId.
    /*  if (!is_skipping_vehicle && !pricing?.vehicle_id && hasVehicle) {
     findOrCreateVehicleId(pricing, account.customer_id, dispatch, vehicles);
     } */

    if (!homeAddress.addressNameSelected) {
      loadCompatibleDates(location.clientLocationId, cart).then((dates) => {
        dispatch({
          type: 'SET_COMPATIBLE_DATES',
          compatibleDates: dates,
        });
      });
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);


    useEffect(() => {
      const { finalTaxedTotalDollars } = calculateCosts(
        coupon,
        cart,
        account.default_client_location_id,
        taxRate,
        Moment(),
        0,
        customDiscount,
      );
      const serviceIsFree = finalTaxedTotalDollars === 0;
      setIsFree(serviceIsFree);
  
      // Do not ask for payment information
      if (
        serviceIsFree ||
        isFleetUser ||
        skipPaymentInformation(activePaymentMethods, isUsingStripe)
      ) {
        setShowPaymentMethodSection(false);
      } else if (activePaymentMethods.length > 1) {
        setShowPaymentMethodSection(true);
        if (is_hiding_price_in_booking) {
          setShowPaymentMethodSection(false);
        }
      }
    }, [activePaymentMethods, coupon]);

  useEffect(() => {
    // const saved = localStorage.getItem(UPLOADED_IMAGES_ARRAY);
    // handleUploadImageInPrevious(imageArray);

  }, [imageArray]);

  const changeCoupon = (e) => {
    const [code, message] = changeCouponHelper(e, scheduledWorks, couponList);
    setCouponCode(code);
    setCouponMessage(message);
  };

  const submitCoupon = (event) => {
    event.preventDefault();
    if (
      couponCode &&
      !isCouponAlreadyUsed(couponCode, scheduledWorks, couponList)
    ) {
      loadCoupon(couponCode.toUpperCase()).then((coupon) => {
        console.log(coupon);
        console.log(cart);
        if (coupon) {
          const isValid = couponIsValid(
            coupon,
            cart,
            isAtHomeService ? null : account.default_client_location_id,
          );

          if (isValid) {
            dispatch({ type: 'SET_COUPON', coupon });
            setCouponCode('');
          } else {
            dispatch({ type: 'SET_COUPON', coupon: null });
            const message =
              'Sorry, that coupon cannot be applied to your order.';
            setCouponMessage(message);
          }
        }
      });
    }
  };

  function editClick(pathEnd) {
    browserHistory.push(`${pathEnd}`);
  }

  const onInputChange = (e) => {
    const { name, value } = e.target;
    setCustomerInfo((prevState) => ({
      ...prevState, // ✅ Keep existing values
      [name]: value, // ✅ Update only the changed field
    }));
  };

  const handleTextAgreementCheck = () => {
    setAgreedToReceiveTexts((prev) => !prev);
  };

  const noteChange = (event) => {
    const newValue = event.target.value;
    if (newValue.length < 1020) {
      setCustomerNote(newValue);
    } else {
      setCustomerNote(newValue.substring(0, 1020));
    }
  };

  let customerNoteHeader = '';
  if (z3pEnv === 'aaa-norcal') {
    customerNoteHeader =
      'Give us a brief description of the issue you are experiencing with your vehicle (required)';
  } else {
    customerNoteHeader =
      'Anything else we need to know about your service, schedule, or location? (optional)';
  }

  // Create a ref to access the input element
  const fileInputRef = useRef(null);


  function handleUploadImageInPrevious(e) {
    const files = Array.from(e);
    const { swId } = schedule;
    if (
      base64Images.length + files.length > MAX_IMAGES &&
      isImageType.type !== 'old'
    ) {
      setImgError(`You can only upload up to ${MAX_IMAGES} images.`);
      return;
    }
    // Set loading to true before starting the upload

    setLoading(true);
    const newBase64Images = [];
    let isSizeExceeded = false;
    const newBase64ImagesObject = {};
    files.forEach((file) => {
      if (file.size <= MAX_SIZE_BYTES) {
        const reader = new FileReader();
        const fileExtension = file.name.split('.').pop();
        const { vehicle_id } = vehicle;
        const randomID = Math.floor(Math.random() * 1000000);
        const filename = `${vehicle_id}-${randomID}.${fileExtension}`;
        /* if (changeBooking) {
          filename = `${swId}-${filename}`;
        } */
        newBase64ImagesObject.fileName = filename;
        newBase64ImagesObject.id = vehicle_id;
        newBase64ImagesObject.originalFileName = null;
        if (isImageType.type === 'old') {
          newBase64ImagesObject.originalFileName = isImageType.old_image_name;
          setBase64Images((prevBase64Images) =>
            prevBase64Images.filter((_, i) => i !== isImageType.index),
          );
        }
        newBase64ImagesObject.folder = folderName;
        reader.onloadend = () => {
          newBase64Images.push({
            fileName: filename,
            id: vehicle_id,
            originalFileName: null,
            folder: folderName,
            base64: reader.result.substr(reader.result.indexOf(',') + 1),
            preview: reader.result,
          });
          newBase64ImagesObject.base64 = reader.result.substr(
            reader.result.indexOf(',') + 1,
          );
          // Ensure state update happens once all files are read
          if (newBase64Images.length === files.length) {
            setBase64Images((prevBase64Images) => [
              ...prevBase64Images,
              ...newBase64Images,
            ]);
          }
        };

        reader.readAsDataURL(file);
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      } else {
        isSizeExceeded = true;
      }
    });

    if (isSizeExceeded) {
      setImgError(
        `One or more files exceed the size limit of ${MAX_SIZE_MB} MB.`,
      );
    } else {
      setImgError(null);
    }
  };


  const handleOnDropImageUpload = (event) => {
    event.preventDefault();
    const files = Array.from(event.dataTransfer.files);
    const { swId } = schedule;
    if (
      base64Images.length + files.length > MAX_IMAGES &&
      isImageType.type !== 'old'
    ) {
      setImgError(`You can only upload up to ${MAX_IMAGES} images.`);
      return;
    }
    // Set loading to true before starting the upload

    setLoading(true);
    const newBase64Images = [];
    let isSizeExceeded = false;
    const newBase64ImagesObject = {};
    files.forEach((file) => {
      if (file.size <= MAX_SIZE_BYTES) {
        const reader = new FileReader();
        const fileExtension = file.name.split('.').pop();
        const { vehicle_id } = vehicle;
        const randomID = Math.floor(Math.random() * 1000000);
        const filename = `${vehicle_id}-${randomID}.${fileExtension}`;
        /* if (changeBooking) {
          filename = `${swId}-${filename}`;
        } */
        newBase64ImagesObject.fileName = filename;
        newBase64ImagesObject.id = vehicle_id;
        newBase64ImagesObject.originalFileName = null;
        if (isImageType.type === 'old') {
          newBase64ImagesObject.originalFileName = isImageType.old_image_name;
          setBase64Images((prevBase64Images) =>
            prevBase64Images.filter((_, i) => i !== isImageType.index),
          );
        }
        newBase64ImagesObject.folder = folderName;
        reader.onloadend = () => {
          newBase64Images.push({
            fileName: filename,
            id: vehicle_id,
            originalFileName: null,
            folder: folderName,
            base64: reader.result.substr(reader.result.indexOf(',') + 1),
            preview: reader.result,
          });
          newBase64ImagesObject.base64 = reader.result.substr(
            reader.result.indexOf(',') + 1,
          );
          // Ensure state update happens once all files are read
          if (newBase64Images.length === files.length) {
            setBase64Images((prevBase64Images) => [
              ...prevBase64Images,
              ...newBase64Images,
            ]);
          }
        };
        reader.readAsDataURL(file);
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      } else {
        isSizeExceeded = true;
      }
    });

    if (isSizeExceeded) {
      setImgError(
        `One or more files exceed the size limit of ${MAX_SIZE_MB} MB.`,
      );
    } else {
      setImgError(null);
    }
  };

    const handleImageUploadAPI = async (newBookingImages) => {
      if (newBookingImages.length > 0) {
        const uploadResults = await Promise.all(
          newBookingImages.map(async (imagesObject) => {
            const result = await uploadVehicleImages(imagesObject);
  
            // Handle non-200 responses
            if (!result || result.status !== 200) {
              const errorText = await result?.text?.();
              alert(`Critical Error1: ${errorText || 'Unknown error occurred'}`);
              return null;
            }
  
            return result; // Success case
          }),
        );
  
        // Check if any uploads failed
        const failedUploads = uploadResults.filter((res) => res === null);
        if (failedUploads.length > 0) {
          console.warn(`${failedUploads.length} image(s) failed to upload.`);
        } else {
          console.log('All images uploaded successfully!');
        }
      }
    };

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    console.log("My object: " + JSON.stringify(files));
    const { swId } = schedule;
    if (
      base64Images.length + files.length > MAX_IMAGES &&
      isImageType.type !== 'old'
    ) {
      setImgError(`You can only upload up to ${MAX_IMAGES} images.`);
      return;
    }
    // Set loading to true before starting the upload

    setLoading(true);
    const newBase64Images = [];
    let isSizeExceeded = false;
    const newBase64ImagesObject = {};
    files.forEach((file) => {
      if (file.size <= MAX_SIZE_BYTES) {
        const reader = new FileReader();
        const fileExtension = file.name.split('.').pop();
        const { vehicle_id } = vehicle;
        const randomID = Math.floor(Math.random() * 1000000);
        const filename = `${vehicle_id}-${randomID}.${fileExtension}`;
        /* if (changeBooking) {
          filename = `${swId}-${filename}`;
        } */
        newBase64ImagesObject.fileName = filename;
        newBase64ImagesObject.id = vehicle_id;
        newBase64ImagesObject.originalFileName = null;
        if (isImageType.type === 'old') {
          newBase64ImagesObject.originalFileName = isImageType.old_image_name;
          setBase64Images((prevBase64Images) =>
            prevBase64Images.filter((_, i) => i !== isImageType.index),
          );
        }
        newBase64ImagesObject.folder = folderName;
        reader.onloadend = () => {
          newBase64Images.push({
            fileName: filename,
            id: vehicle_id,
            originalFileName: null,
            folder: folderName,
            base64: reader.result.substr(reader.result.indexOf(',') + 1),
            preview: reader.result,
          });
          newBase64ImagesObject.base64 = reader.result.substr(
            reader.result.indexOf(',') + 1,
          );
          // Ensure state update happens once all files are read
          if (newBase64Images.length === files.length) {
            setBase64Images((prevBase64Images) => [
              ...prevBase64Images,
              ...newBase64Images,
            ]);
          }
        };

        reader.readAsDataURL(file);
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      } else {
        isSizeExceeded = true;
      }
    });

    if (isSizeExceeded) {
      setImgError(
        `One or more files exceed the size limit of ${MAX_SIZE_MB} MB.`,
      );
    } else {
      setImgError(null);
    }
  };
  const handleImageRemove = (index) => {
    const updatedItems = [...base64Images];
    // Update the object at the specific index
    const newData = {
      base64: '',
      preview: '',
      originalFileName: updatedItems[index].fileName,
    };
    updatedItems[index] = {
      ...updatedItems[index], // Spread to copy the original object
      ...newData, // Apply the new data
    };
    const isConfirmed = window.confirm(
      'Are you sure want to remove this image?',
    );

    if (isConfirmed) {
      /* if (changeBooking) {
        deleteVehicleImage(updatedItems[index]).then((result) => {
           if (result.status !== 200) {
             result.text().then((x) => {
               setImgError(`Critical Error: ${x}`);
             });
             return null;
           }
         });
      } */
      setBase64Images((prevBase64Images) =>
        prevBase64Images.filter((_, i) => i !== index),
      );

      if (fileInputRef.current) {
        fileInputRef.current.value = ''; // Clear the file input
      }
    }
  };

  const handleImageEdit = (index) => {
    fileInputRef.current.click();
    const old_image = base64Images[index];
    setIsImageType({
      type: 'old',
      old_image_name: old_image.fileName,
      index,
    });
  };

  const handleHowDidHearChange = (event) => {
    setSelectedHowDidHear(event.target.value);
  };

  const hasAllCustomerInfo = customerInfo !== "" &&
    !Object.values(customerInfo).some(value => !String(value).trim());
  const accountHasValues = Object.keys(account).length > 0;
  // const enableContinue = hasAllCustomerInfo ? ((agreedToReceiveTexts && !hasAccessToken() && hasAllCustomerInfo))
  //   : (agreedToReceiveTexts && hasAccessToken() && accountHasValues)
  const enableContinue = hasAllCustomerInfo ? ((agreedToReceiveTexts  && hasAllCustomerInfo))
    : (agreedToReceiveTexts  && accountHasValues)

  const handleContinue = () => {
    const { z3p_client_name: z3pEnv, is_skipping_vehicle } = z3pConfiguration;
    const { clientLocationId } = customerLocation;

    const sched = {
      ...schedule,
      customerNote,
    };
    // if (!hasAccessToken()) {
      const firstName = customerInfo.first_name;
      const lastName = customerInfo.last_name;
      const { email } = customerInfo;
      const qualifiedPhone = `+1${customerInfo.cellPhone}`;
      const customer = {
        first_name: firstName,
        last_name: lastName,
        email,
        phone: qualifiedPhone,
        client_location_id: clientLocationId,
        how_did_hear: selectedHowDidHear,
        fleet_account_name: fleetAccountName,
        is_fleet_user: !!fleetAccountName,
      };
      const payload = {
        customer,
        pricing,
      };

      tracRudderStackkEvent('SimpleSchedule_New_Account', {
        proname: z3pConfiguration.z3p_client_name,
        first_name: customer.first_name,
        last_name: customer.last_name,
        email: customer.email,
        mobile: customer.phone,
      });

      setProcessing(true);

      apiPost('/booking/customer-signup', payload).then((response) => {
        if (response.status === 409) {
          setCustomerExists(true);
          setProcessing(false);
          return;
        }
        if (response.status !== 200) {
          response.text().then(() => {
            const inputValidationMessage =
              'Sorry, something went wrong. Please try again.';
            setInputValidationMessage(inputValidationMessage);
            setProcessing(false);
          });
          return;
        }

        response.json().then((json) => {
          const analyticsEvent = {
            event: 'Account Created',
            event_category: 'Account',
            event_label: 'Account Created',
            userId: json.customer_id,
            email: customer.email,
            firstName: customer.first_name,
            lastName: customer.last_name,
            phone: customer.phone,
            vehicle: payload.pricing,
            referring_code: referrer.code,
            referring_source: referrer.source,
            fleet_account_name: customer.fleetAccountName,
          };

          // Push to dataLayer to be picked up by GTM
          if (typeof dataLayer !== 'undefined') {
            dataLayer.push(analyticsEvent);
          }

          // Add gtag event to be picked up by Google Analytics
          if (window && window.gtag && window.location) {
            window.gtag('event', 'Account Created', analyticsEvent);
          }

          if (shouldUseFacebookPixel(z3pEnv)) {
            // Tell Facebook Pixel about this new customer
            fbq('track', 'CompleteRegistration');
          }

          storeAccessToken(json.token);

          if (is_skipping_vehicle) {
            dispatch({ type: 'SET_VEHICLES', vehicles: [] });
          } else {
            dispatch({ type: 'SET_VEHICLES', vehicles: json.vehicles });
            const vehicleData = {
              year: pricing.year,
              make: pricing.make,
              model: pricing.model,
              trim: pricing.trim,
              input_method_type: pricing.input_method_type,
              vehicleType: pricing.vehicleType,
            };
            createVehicle(
              vehicleData,
              json.customer_id,
              dispatch,
              json.vehicles,
            ).then(() => {
              console.log('success Vehicle');
            });
            // If a duplicate vehicle was found and replaced, select the updated vehicle
            if (json.vehicle_id !== pricing.vehicle_id) {
              const selectedVehicle = json.vehicles.find(
                (v) => v.vehicle_id === json.vehicle_id,
              );

              if (selectedVehicle) {
                const vehicleType = getVehicleType(selectedVehicle);
                dispatch({ type: 'SELECT_VEHICLE', vehicle: selectedVehicle });
                dispatch({
                  type: 'SELECT_VEHICLE_TYPE',
                  vehicleType,
                });
              }
            }
          }

          customer.customer_id = json.customer_id;
          customer.default_client_location_id = clientLocationId;

          // If customer record was previously created, replace with data saved in DB
          if (json.existing_customer) {
            customer.first_name = json.existing_customer.first_name;
            customer.last_name = json.existing_customer.last_name;
            customer.phone = json.existing_customer.phone;
            customer.fleet_account_name =
              json.existing_customer.fleet_account_name;
          }
          dispatch({ type: 'SET_ACCOUNT', account: customer });

          const page = !cart || cart.length === 0 ? 'save' : 'review';

          // To support guest checkout, need to confirm that one of the following is true before creating an address:
          // If we have address details but no ID saved, create an address
          // If we have address details and an ID saved, only create an address if the customer IDs do not match (old address was associated with different email)

          if (
            homeAddress &&
            !_.isEmpty(homeAddress.address) &&
            (!homeAddress.addressIDSelected ||
              json.customer_id !== homeAddress.address.customer_id)
          ) {
            const payload = {
              ...homeAddress.address,
              is_deleted: false,
              is_primary: false,
            };
            // Don't send customer address ID in payload since we're creating a new one
            delete payload.customer_address_id;
            // If user is not logged in, use customer ID from json response
            if (!json.token) {
              payload.customer_id = json.customer_id;
            }
            apiPost('/customer/address', payload)
              .then((r) => {
                if (!r.ok) {
                  throw Error(r.statusText);
                }
                return r.json();
              })
              .then((j) => {
                if (homeAddress.addressNameSelected) {
                  dispatch({
                    type: 'SET_HOME_ADDRESS',
                    ...homeAddress,
                    address: j,
                    addressIDSelected: j.id,
                  });
                }
                setProcessing(false);
                if (json.invalid_password) {
                  /* this.setState({ isInvalidPasswordModalOpen: true }); */
                } else {
                  dispatch({ type: 'SET_SCHEDULE', schedule: sched });
                  dispatch({
                    type: 'SET_BOOKING_IMAGES',
                    bookingImages: base64Images,
                  });
                  // browserHistory.push(`/pricing/${page}`);
                 submitScheduledWork(hasAccessToken(), j.id)
                }
              })
              .catch((e) => {
                Raven.captureException(e);
                setProcessing(false);
              });
          } else {
            setProcessing(false);
            if (json.invalid_password) {
              /* this.setState({ isInvalidPasswordModalOpen: true }); */
            } else {
              dispatch({ type: 'SET_SCHEDULE', schedule: sched });
              dispatch({
                type: 'SET_BOOKING_IMAGES',
                bookingImages: base64Images,
              });
              // browserHistory.push(`/pricing/${page}`);
              submitScheduledWork(hasAccessToken())
            }
          }
        });
      });
    // } else {
    //   setProcessing(true);
    //   dispatch({ type: 'SET_SCHEDULE', schedule: sched });
    //   dispatch({ type: 'SET_BOOKING_IMAGES', bookingImages: base64Images });
    //   setProcessing(false);
    //  //   browserHistory.push(`/pricing/review`);
    //  alert(JSON.stringify(homeAddress));
    //   submitScheduledWork(hasAccessToken())
    // }
  };

  /////// call Api directly from confirmation page

  const submitScheduledWork = (token, customeraddressid) => {
    // Send the validated coupon if present.
    // Else send the string that's currently in the "coupon input" text box.
    let couponUpper = '';
    if (coupon && coupon.coupon_code) {
      couponUpper = coupon.coupon_code.toUpperCase();
    } else {
      couponUpper = couponCode.toUpperCase();
    }
    // Concat all the notes into one.
    // In the future, we will make it so Brain2 accepts multiple separate notes.
    tireDetails.tireNote = createTireNote(tireNotes);
    tireDetails.tireNotes = tireNotes;

    const additionalPhoneNumbers = additionalContactList.map(
      (contact) => contact.phoneNumber?.length === 10 && contact.phoneNumber,
    );

    const updatedCart = [];
    // If a service has quantity more than 1, create that number of services
    cart.forEach((service) => {
      const quantity = service.quantity || 1;
      if (quantity > 1) {
        for (let i = 0; i < quantity; i += 1) {
          let newService = { ...service };
          if (service.short_name === 'Tire Installation') {
            newService = {
              ...newService,
                tire_quantity: localStorage.getItem(LOCAL_TireQuntityValue) ? parseInt(localStorage.getItem(LOCAL_TireQuntityValue), 10) : null,
            };
          }
          
          updatedCart.push(newService);
        }
      } else {
        let newService = { ...service };
        if (service.short_name === 'Tire Installation') {
          newService = {
            ...newService,
             tire_quantity: localStorage.getItem(LOCAL_TireQuntityValue) ? parseInt(localStorage.getItem(LOCAL_TireQuntityValue), 10) : null,
          };
        }
        updatedCart.push(newService);
      }
    });

    const keyLocation_Note = localStorage.getItem(LOCAL_KEY_Location);
    const payload = {
      pricing,
      account,
      client_location_id: isAtHomeService
        ? null
        : customerLocation.clientLocationId,
      vehicle_id: pricing?.vehicle_id || null,
      keyosk_id: keyosk && keyosk.keyosk_id,
      parking_id: parking && parking.parking_id,
      customer_address_id: customeraddressid,
      // key_exchange_note: homeAddress.keyLocationNote,
      key_exchange_note: keyLocation_Note,
      other_service_description: localStorage.getItem(LOCAL_DECRIPTION_KEY) || "",
      schedule,
      services: updatedCart,
      coupon_code: couponUpper,
      referrer_code: referrer.code,
      tireDetails,
      detailingNote,
      // payment_method_id:
      //   selectedPaymentMethod && !isFree
      //     ? selectedPaymentMethod.payment_method_id
      //     : null,
      payment_method_id:
        selectedPaymentMethod 
          ? selectedPaymentMethod.payment_method_id
          : null,
      additional_phone_numbers: additionalPhoneNumbers,
      tip_amount_dollars: tipAmountDollars,
      tip_entry_method: tipAmountDollars > 0 ? 'checkout' : null,
      quote_id: quoteId,
     //tire_quantity: localStorage.getItem(LOCAL_TireQuntityValue) ? localStorage.getItem(LOCAL_TireQuntityValue) : null,
    };

    if (customDiscount) {
      payload.custom_discount_amount_dollars =
        customDiscount.customDiscountAmountDollars;
      payload.custom_discount_reason = customDiscount.customDiscountReason;
    }

    if (isUsingStripe && token) {
      payload.stripe_token = token.id;
    } else if (isUsingSquare && token) {
      payload.square_token = {};
    }

    setPaymentFailed(false); // in case of retries
    setTimeTakenError(false);
    setProcessing(true);
    console.log("-----payout-----",JSON.stringify(payload));
// return;
    apiPost('/booking/scheduled-work', payload).then((response) => {
      if (response.status !== 200) {
        response.text().then((x) => {
          alert(`Critical Error: ${x}`);
        });
        setProcessing(false);
        return;
      }

      response.json().then((json) => {
        const newBookingImages = bookingImages.map((file) => ({
          ...file,
          id: json.newScheduledWork.scheduled_work_id,
          fileName: `${json.newScheduledWork.scheduled_work_id}-${file.fileName}`,
        }));
        handleImageUploadAPI(newBookingImages);
        // if(newBookingImages.length > 0){
        //   newBookingImages.forEach((imagesObject) => {
        //     uploadVehicleImages(imagesObject).then((result) => {
        //       if (result.status !== 200) {
        //         result.text().then((x) => {
        //           alert(`Critical Error: ${x}`);
        //         });
        //         return null;
        //       }
        //     });
        //   });
        // }
        if (json.Status === 'Failure' && json.Message === 'Invalid card') {
          setPaymentFailed(true);
          setProcessing(false);
          return;
        }
        if (
          json.Status === 'Failure' &&
          json.Message === 'Double booking attempted'
        ) {
          setTimeTakenError(true);
          setProcessing(false);
          return;
        }

        // TODO: This revenue calculation isn't exactly correct
        const revenue = payload.services.reduce(
          (sum, service) => sum + service.total_cost_dollars,
          0,
        );

        const products = payload.services.map((service) => ({
          sku: service.service_offering_id,
          name: service.long_name,
          price: service.total_cost_dollars,
          parts_cost_dollars: service.parts_cost_dollars,
          labor_cost_dollars: service.labor_cost_dollars,
        }));

        const serviceDate = Moment(
          payload.schedule.date,
          'YYYY-MM-DD',
        ).toISOString();
        const analyticsEvent = {
          event: 'Order Completed',
          event_category: 'Order',
          event_label: 'Order Completed',
          revenue,
          products: JSON.stringify(products),
          serviceDate,
          arriveTime: Moment(
            `${payload.schedule.date} ${payload.schedule.arrive}`,
            'YYYY-MM-DD h:mm A',
          ).toISOString(),
          leaveTime: Moment(
            `${payload.schedule.date} ${payload.schedule.leave}`,
            'YYYY-MM-DD h:mm A',
          ).toISOString(),
          service_vehicle_id: payload.schedule.serviceVehicleId,
          note: payload.schedule.note,
          vehicle_make: payload.pricing?.make,
          vehicle_model: payload.pricing?.model,
          vehicle_year: payload.pricing?.year,
          coupon: payload.coupon,
          location: payload.account.location,
          keyosk: payload.keyosk,
          parking: payload.parking,
        };

        tracRudderStackkEvent('Service_Confirmation', {
          proname: z3pConfiguration.z3p_client_name,
          path: window.location.pathname,
          url: window.location.href,
          // eslint-disable-next-line no-undef
          title: document.title,
          // eslint-disable-next-line no-undef
          referrer: document.referrer,
          service_date: payload.schedule.date,
          service_time: `${payload.schedule.plannedArrivalTime} to ${payload.schedule.plannedDepartureTime}`,
          Payment_Method: selectedPaymentMethod?.name,
        });

        // Push to dataLayer to be picked up by GTM
        if (typeof dataLayer !== 'undefined') {
          dataLayer.push(analyticsEvent);
        }

        // Add gtag event to be picked up by Google Analytics
        if (window && window.gtag && window.location) {
          window.gtag('event', 'Order Completed', analyticsEvent);
        }

        if (shouldUseFacebookPixel(z3pEnv)) {
          // Tell Facebook Pixel about this purchase
          fbq('track', 'Purchase', {
            currency: 'USD',
            value: revenue,
            content_ids: cart.map((service) => service.service_offering_id),
          });
        }

        /* dispatch({ type: 'SET_CART', cart: [] }); */

        dispatch({
          type: 'CLEAR_TIRE_DETAILS',
        });

        dispatch({
          type: 'SET_DETAILING_NOTE',
          detailingNote: '',
        });

        dispatch({
          type: 'SET_COUPON',
          coupon: null,
        });

        dispatch({
          type: 'SET_CUSTOM_DISCOUNT',
          customDiscount: null,
        });

        dispatch({
          type: 'CLEAR_MESSAGES',
        });

        dispatch({
          type: 'SET_SCHEDULED_WORKS',
          scheduledWorks: json.scheduledWorks,
        });

        //dispatch({ type: 'SET_SCHEDULE_DATE', date: '' });

        dispatch({
          type: 'SET_SELECTED_PAYMENT_METHOD',
          selectedPaymentMethod: null,
        });

        dispatch({
          type: 'SET_QUOTE_ID',
          quoteId: null,
        });

        dispatch({
          type: 'SET_BOOKING_IMAGES',
          bookingImages: [],
        });
        //localStorage.clear();
        // dispatch({ type: 'SET_CART', cart: [] });
        // dispatch({ type: 'SET_SCHEDULE', schedule: {} });
        localStorage.setItem("ShopNowHyperLink", "");
        localStorage.setItem(LOCAL_KEY_Location, "");
        // localStorage.setItem(LOCAL_DECRIPTION_KEY, "");
        // localStorage.setItem(LOCAL_TireQuntityValue, "");
        localStorage.setItem(LOCAL_STORAGE_KEY, "");


        if (z3pEnv === 'bigs-mobile-detailing') {
          window.location = 'https://bigsmobile.com/thank-you-zippity/';
        } else {
          browserHistory.push('/pricing/finished');
        }
      });
    });
  };

  ////////////////////////////////////

  let location = null;
  let scheduleDisplay = null;
  let contact = null;
  let vehicleSection = null;
  let additionalInfo = null;
  const isFleetUser = account.is_fleet_user;
  const sectionDivider = <div className="section_divider" />;

  // if (account?.first_name !== undefined) {
  //   contact = (
  //     <div className="customer-info">
  //       <div className="header">
  //         <h5>Customer Info</h5>
  //         <a
  //           href="javascript:;"
  //           onClick={() => editClick('/settings')}
  //           style={{ display: 'none' }}
  //         >
  //           <svg
  //             xmlns="http://www.w3.org/2000/svg"
  //             width="24"
  //             height="24"
  //             viewBox="0 0 24 24"
  //             fill="none"
  //           >
  //             <path
  //               d="M7 7.00012H6C5.46957 7.00012 4.96086 7.21084 4.58579 7.58591C4.21071 7.96098 4 8.46969 4 9.00012V18.0001C4 18.5306 4.21071 19.0393 4.58579 19.4143C4.96086 19.7894 5.46957 20.0001 6 20.0001H15C15.5304 20.0001 16.0391 19.7894 16.4142 19.4143C16.7893 19.0393 17 18.5306 17 18.0001V17.0001M16 5.00012L19 8.00012M20.385 6.58511C20.7788 6.19126 21.0001 5.65709 21.0001 5.10011C21.0001 4.54312 20.7788 4.00895 20.385 3.61511C19.9912 3.22126 19.457 3 18.9 3C18.343 3 17.8088 3.22126 17.415 3.61511L9 12.0001V15.0001H12L20.385 6.58511Z"
  //               stroke="black"
  //               strokeWidth="2"
  //               strokeLinecap="round"
  //               strokeLinejoin="round"
  //             />
  //           </svg>
  //         </a>
  //       </div>
  //       <ul>
  //         <li>
  //           {account.first_name} {account.last_name}
  //         </li>
  //         <li>{account.email}</li>
  //         <li>{account.phone}</li>
  //       </ul>
  //     </div>
  //   );
  // } else {
  //   contact = (
  //     <Row>
  //       <div className="customer-info">
  //         <div className="header header2">
  //           <h5>Your Info</h5>
  //         </div>
  //         <div className="customer-detail">
  //           <div className="input-field col m12">
  //             <input
  //               id="first_name"
  //               name="first_name"
  //               type="text"
  //               className="validate"
  //               required="required"
  //               pattern=".*[^ ].*"
  //               onChange={onInputChange}
  //             />
  //             <label htmlFor="first_name">First Name *</label>
  //           </div>
  //           <div className="input-field col m12">
  //             <input
  //               id="last_name"
  //               name="last_name"
  //               type="text"
  //               className="validate"
  //               required="required"
  //               pattern=".*[^ ].*"
  //               onChange={onInputChange}
  //             />
  //             <label htmlFor="last_name">Last Name *</label>
  //           </div>
  //           <div className="input-field col m12">
  //             <input
  //               id="email"
  //               name="email"
  //               type="email"
  //               className="validate"
  //               required="required"
  //               onChange={onInputChange}
  //             />
  //             <label htmlFor="email">Email *</label>
  //           </div>

  //           <div className="input-field col m12">
  //             <Cleave
  //               id="cellPhone"
  //               name="cellPhone"
  //               required="required"
  //               options={{
  //                 blocks: [3, 3, 4],
  //                 delimiter: '-',
  //                 numericOnly: true,
  //               }}
  //               onChange={onInputChange}
  //             />
  //             <label htmlFor="cellPhone">Mobile Phone*</label>
  //           </div>
  //           {showFleetField && (
  //             <div className="input-field col m12 s12">
  //               <input
  //                 id="fleetAccountName"
  //                 name="fleetAccountName"
  //                 type="text"
  //                 className="validate"
  //                 onChange={(e) => setFleetAccountName(e.target.value)}
  //               />
  //               <label htmlFor="fleetAccountName">
  //                 Fleet Account Name (Optional)
  //               </label>
  //             </div>
  //           )}
  //           {isHowDidHearQuestionEnabled && howDidHearOptions?.length > 0 && (
  //             <Select
  //               s={12}
  //               m={6}
  //               onChange={() => handleHowDidHearChange()}
  //               id="howDidHear"
  //               name="howDidHear"
  //               value={selectedHowDidHear}
  //             >
  //               <option value="" disabled>
  //                 How did you hear about us?
  //               </option>
  //               {howDidHearOptions?.map((option, index) => {
  //                 return (
  //                   <option key={index} value={option}>
  //                     {option}
  //                   </option>
  //                 );
  //               })}
  //             </Select>
  //           )}
  //         </div>
  //       </div>
  //     </Row>
  //   );
  // }
  contact = (
    <Row>
      <div className="customer-info">
        <div className="header header2">
          <h5>Your Info</h5>
        </div>
        <div className="customer-detail">
          <div className="input-field col m12">
            <input
              id="first_name"
              name="first_name"
              type="text"
              className="validate"
              required="required"
              pattern=".*[^ ].*"
              onChange={onInputChange}
            />
            <label htmlFor="first_name">First Name *</label>
          </div>
          <div className="input-field col m12">
            <input
              id="last_name"
              name="last_name"
              type="text"
              className="validate"
              required="required"
              pattern=".*[^ ].*"
              onChange={onInputChange}
            />
            <label htmlFor="last_name">Last Name *</label>
          </div>
          <div className="input-field col m12">
            <input
              id="email"
              name="email"
              type="email"
              className="validate"
              required="required"
              onChange={onInputChange}
            />
            <label htmlFor="email">Email *</label>
          </div>

          <div className="input-field col m12">
            <Cleave
              id="cellPhone"
              name="cellPhone"
              required="required"
              options={{
                blocks: [3, 3, 4],
                delimiter: '-',
                numericOnly: true,
              }}
              onChange={onInputChange}
            />
            <label htmlFor="cellPhone">Mobile Phone*</label>
          </div>
          {showFleetField && (
            <div className="input-field col m12 s12">
              <input
                id="fleetAccountName"
                name="fleetAccountName"
                type="text"
                className="validate"
                onChange={(e) => setFleetAccountName(e.target.value)}
              />
              <label htmlFor="fleetAccountName">
                Fleet Account Name (Optional)
              </label>
            </div>
          )}
          {isHowDidHearQuestionEnabled && howDidHearOptions?.length > 0 && (
            <Select
              s={12}
              m={6}
              onChange={() => handleHowDidHearChange()}
              id="howDidHear"
              name="howDidHear"
              value={selectedHowDidHear}
            >
              <option value="" disabled>
                How did you hear about us?
              </option>
              {howDidHearOptions?.map((option, index) => {
                return (
                  <option key={index} value={option}>
                    {option}
                  </option>
                );
              })}
            </Select>
          )}
        </div>
      </div>
    </Row>
  );

  additionalInfo = (
    <Row>
      <div className="customer-info">
        <div className="customer-detail">
          <div className="text_message_agreement">
            <Checkbox
              id="text_message_agreement"
              onChange={(e) => handleTextAgreementCheck(e)}
              checked={agreedToReceiveTexts}
              className="filled-in"
              label="I agree to receive text messages for important updates and notifications related to my appointment."
            />
          </div>
          {!diagnostic.selected && (
            <div>
              <div className="header">
                <h5>Additional info</h5>
              </div>
              <textarea
                rows="7"
                id="note"
                value={customerNote}
                placeholder={customerNoteHeader}
                maxLength="1020"
                onChange={noteChange}
              />
            </div>
          )}
          {/* ///////// */}
          {/* <div className="image-box">
            <input
              type="file"
              accept="image/png, image/jpeg"
              multiple
              ref={fileInputRef}
              style={{ display: 'none' }}
              disabled={loading}
              onChange={handleImageUpload}
              id="booking_image"
            />
            <label htmlFor="booking_image" style={{ cursor: 'pointer' }}>
              <div className="booking_image">
                <h6>Upload image</h6>
                <p>
                  {' '}
                  Supports:
                  <span>
                    {' '}
                    JPG and PNG up to 5MB <br /> Up to 5 images.
                  </span>
                </p>
              </div>
            </label>
            <div className="preview_img_box">
              {loading && <h5 className="image-loader">Loading...</h5>}
              {!loading &&
                base64Images.map((image, index) => (
                  <div key={index} className="preview">
                    <div className="preview_img">
                      <img src={image.preview} alt="Preview" />
                    </div>
                    <button
                      htmlFor="booking_image"
                      className="edit_image"
                      title="Edit"
                      onClick={() => handleImageEdit(index)}
                    >
                      <i className="material-icons">edit</i>
                    </button>
                    <button
                      className="remove_image"
                      color="danger"
                      title="Delete"
                      onClick={() => handleImageRemove(index)}
                    >
                      <i className="material-icons">delete</i>
                    </button>
                  </div>
                ))}
            </div>

            {imgError && <p className="error">{imgError}</p>} 
            <div className="preview_img_box">
              {loading && <h5 className="image-loader">Loading...</h5>}
              {!loading &&
                base64Images.map((image, index) => (
                  <div key={index} className="preview">
                    <div className="preview_img">
                      <img src={image.preview} alt="Preview" />
                    </div>
                    <button
                      htmlFor="booking_image"
                      className="edit_image"
                      title="Edit"
                      onClick={() => handleImageEdit(index)}
                    >
                      <i className="material-icons">edit</i>
                    </button>
                    <button
                      className="remove_image"
                      color="danger"
                      title="Delete"
                      onClick={() => handleImageRemove(index)}
                    >
                      <i className="material-icons">delete</i>
                    </button>
                  </div>
                ))}
            </div>
          </div>
          {/* //////// */}
          <ImageUpload vehicle={vehicle}/>
        </div>
      </div>
    </Row>
  );

  if (isAtHomeService) {
    const { address } = homeAddress;
    location = (
      <div className="d-flex">
        <h6>Service Location</h6>
        <ul>
          {schedule.isPickupAndDelivery && (
            <li style={{ fontSize: '15px' }}>
              Vehicle will be picked up from:
            </li>
          )}
          <a
            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address.address_line_1, address.address_line_2, address.city, address.state, address.postal_code)}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#00B8D9", cursor: 'pointer' }}>
            <li>
              <strong>{address.display_name}</strong>
            </li>
            <li>{address.address_line_1}</li>
            <li>{address.address_line_2}</li>
            <li>
              {address.city}, {address.state} {address.postal_code}
            </li>
          </a>
        </ul>
        {schedule.isPickupAndDelivery && <p>{pickupDeliveryServiceLocation}</p>}
      </div>
    );
  } else if (keyosk && parking) {
    location = (
      <div className="d-flex">
        <h6>Location</h6>
        <ul>
          <li>Keyosk: {keyosk.name}</li>
          <li>Parking Lot: {parking.name}</li>
        </ul>
      </div>
    );
  } else if (hasShopService) {
    const shopAddress = clientLocations.find(
      (cl) => cl.client_location_id === customerLocation.clientLocationId,
    );
    location = (
      <div className="d-flex">
        <h6>Location</h6>
        <ul>
          <li>{customerLocation.location}</li>
          <li>
            <a
              href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(shopAddress.address.one_line_human_readable_address)}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#00B8D9", cursor: 'pointer' }}
            >
              {shopAddress.address.one_line_human_readable_address}
            </a>
          </li>

        </ul>
      </div>
    );
  } else {
    const { address } = homeAddress;
    location = (
      <div className="d-flex">
        <h6>Service Location</h6>
        <ul>
          {schedule.isPickupAndDelivery && (
            <li style={{ fontSize: '15px' }}>
              Vehicle will be picked up from:
            </li>
          )}
          <a
            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address.address_line_1, address.address_line_2, address.city, address.state, address.postal_code)}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#00B8D9", cursor: 'pointer' }}>
            <li>
              <strong>{address.display_name}</strong>
            </li>
            <li>{address.address_line_1}</li>
            <li>{address.address_line_2}</li>
            <li>
              {address.city}, {address.state} {address.postal_code}
            </li>
          </a>
        </ul>
        {schedule.isPickupAndDelivery && <p>{pickupDeliveryServiceLocation}</p>}
      </div>
    );
  }

  if (schedule) {
    scheduleDisplay = (
      // <div className="d-flex">
      <div>
        <h6>Date & Time</h6>
        <ul>
          <li>
            {schedule.date ? (
              <PrettyDate dateString={schedule.date} />
            ) : (
              'Date not yet set - we will reach out!'
            )}
          </li>
          <li>
            {schedulingSystem === 'time_slots'
              ? `${datetimeToTime(schedule.confirmedAppointmentStartTime)}`
              : `${schedule.plannedArrivalTime} - ${schedule.plannedDepartureTime}`}
          </li>
        </ul>
      </div>
    );
  }

  if (vehicles) {
    vehicleSection = (
      <div className="d-flex">
        <h6>Vehicle</h6>
        <ul>
          <li>
            <ReviewYourCar />
          </li>
        </ul>
      </div>
    );
  }

  const couponEntryForm = () => {
    const title = ['zippity', 'uvngo'].includes(z3pEnv)
      ? 'Gift Card or Coupon (Optional)'
      : 'Coupon (Optional)';
    return (
      <form>
        <Row className="d-flex">
          <Col s={8} m={9} l={9}>
            <input
              id="coupon-code-input"
              type="text"
              value={couponCode}
              placeholder="Enter your coupon code"
              onChange={changeCoupon}
            />
          </Col>
          <Col s={4} m={3} l={3}>
            <Button
              className="header coupon_btn"
              onClick={submitCoupon}
              disabled={isCouponAlreadyUsed(
                couponCode,
                scheduledWorks,
                couponList,
              )}
            >
              &nbsp;Apply&nbsp;
            </Button>
          </Col>
        </Row>
      </form>
    );
  };

  let existingCouponHtml = <span />;
  if (coupon && coupon.coupon_code) {
    existingCouponHtml = (
      <Card key="couponCard" className="couponCard" title="Coupon Applied!">
        {coupon.coupon_code}
      </Card>
    );
  } else if (couponMessage) {
    existingCouponHtml = (
      <Card key="couponCard" className="invalidCouponCard">
        {couponMessage}
      </Card>
    );
  }

  const appointmentSection = (
    <div className="appointment-info">
      <div className="header">
        <h5>Appointment Details</h5>
        <a href="javascript:;" onClick={() => editClick('/pricing/place')}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M7 7.00012H6C5.46957 7.00012 4.96086 7.21084 4.58579 7.58591C4.21071 7.96098 4 8.46969 4 9.00012V18.0001C4 18.5306 4.21071 19.0393 4.58579 19.4143C4.96086 19.7894 5.46957 20.0001 6 20.0001H15C15.5304 20.0001 16.0391 19.7894 16.4142 19.4143C16.7893 19.0393 17 18.5306 17 18.0001V17.0001M16 5.00012L19 8.00012M20.385 6.58511C20.7788 6.19126 21.0001 5.65709 21.0001 5.10011C21.0001 4.54312 20.7788 4.00895 20.385 3.61511C19.9912 3.22126 19.457 3 18.9 3C18.343 3 17.8088 3.22126 17.415 3.61511L9 12.0001V15.0001H12L20.385 6.58511Z"
              stroke="black"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </a>
      </div>
      {location}
      {scheduleDisplay}
      {vehicleSection}
    </div>
  );

  const serviceSection = (
    <div className="service-info">
      <div className="header">
        <h5>Services</h5>
        <a href="javascript:;" onClick={() => editClick('/pricing/simple')}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M7 7.00012H6C5.46957 7.00012 4.96086 7.21084 4.58579 7.58591C4.21071 7.96098 4 8.46969 4 9.00012V18.0001C4 18.5306 4.21071 19.0393 4.58579 19.4143C4.96086 19.7894 5.46957 20.0001 6 20.0001H15C15.5304 20.0001 16.0391 19.7894 16.4142 19.4143C16.7893 19.0393 17 18.5306 17 18.0001V17.0001M16 5.00012L19 8.00012M20.385 6.58511C20.7788 6.19126 21.0001 5.65709 21.0001 5.10011C21.0001 4.54312 20.7788 4.00895 20.385 3.61511C19.9912 3.22126 19.457 3 18.9 3C18.343 3 17.8088 3.22126 17.415 3.61511L9 12.0001V15.0001H12L20.385 6.58511Z"
              stroke="black"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </a>
      </div>
      <ReviewServices
        tipAmountDollars={tipAmountDollars}
        setTipAmountDollars={setTipAmountDollars}
      />
    </div>
  );

  return (
    <Pricing
      currentStep="confirm-appointment"
      h1="Confirm your appointment"
      hideYourCar
      backText="Back To Services"
      hideBreadcrumbs
    >
      <div className="review">
        <Row>
          <Col m={12} className="review-column-left">
            {contact}
            {additionalInfo}
            {sectionDivider}
            {appointmentSection}
            {sectionDivider}
            {serviceSection}
            {!is_hiding_price_in_booking && couponEntryForm()}
            {existingCouponHtml}
            {!is_hiding_price_in_booking && (
              <ReviewPrices
                tipAmountDollars={tipAmountDollars}
                sectionDivider={sectionDivider}
              />
            )}

            <div style={{ marginTop: '40px', padding: '0 18px' }}>
              <Button
                large
                className={`btn header ${processing && 'grey lighten-1'}`}
                disabled={!enableContinue}
                onClick={handleContinue}
              >
                Confirm Appointment
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </Pricing>
  );
};

const styles = {
  imageRow: { display: "flex", flexWrap: "wrap", gap: "5px", justifyContent: "left", },
  imageContainer: {
    position: "relative",
    width: "58px",
    height: "58px",
    borderRadius: "3px",
    overflow: "hidden",
    // backgroundColor: "#eee",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

  },
  thumbnail: { width: "100%", height: "100%", objectFit: "cover", cursor: "pointer" },
  removeButton: {
    position: "absolute",
    top: "4px",
    right: "2px",
    width: "20px",
    height: "20px",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    color: "white",
    border: "none",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "15px",
    fontWeight: "bold",
    cursor: "pointer",
    // zIndex: 10,
    transition: "background-color 0.3s ease",
  },

}

function mapStateToProps(state) {
  return {
    pricing: state.ui.pricing,
    cart: state.ui.cart,
    schedule: state.ui.schedule,
    account: state.ui.account,
    keyosk: state.ui.keyosk,
    parking: state.ui.parking,
    homeAddress: state.ui.homeAddress,
    scheduledWorks: state.ui.scheduledWorks,
    coupon: state.ui.coupon,
    couponList: state.ui.couponList,
    vehicles: state.ui.vehicles,
    customerLocation: state.ui.customerLocation,
    clientLocations: state.ui.clientLocations,
    z3pConfiguration: state.ui.z3pConfiguration,
    diagnostic: state.ui.diagnostic,
    bookingImages: state.ui.bookingImages,
    vehicle: state.ui.pricing,
    referrer: state.ui.referrer,
    tireNotes: state.ui.tireNotes,
    tireDetails: state.ui.tireDetails,
    selectedPaymentMethod: state.ui.selectedPaymentMethod,
    activePaymentMethods: state.ui.activePaymentMethods,

  };
}

export default connect(mapStateToProps, null)(ConfirmAppointment);
